/* amphr-drag-scroll.js — click-and-drag for horizontal snap rails.
 *
 * Binds to any [data-drag-scroll] element. Touch is left completely alone:
 * native scrolling already gives momentum and snapping, and both are better
 * than anything reimplemented here. This exists for the pointer — with a mouse
 * a horizontal rail looks draggable and does nothing, and a trackpad's
 * sideways gesture is not something most people reach for.
 */
(function () {
  'use strict';

  /* Below this the drag counts as a click and the rail stays put, so tapping a
     photo to open the lightbox keeps working. */
  var THRESHOLD = 6;

  function bind(rail) {
    if (rail.dataset.amphrDragBound) return;
    rail.dataset.amphrDragBound = '1';

    var startX = 0;
    var startScroll = 0;
    var pressed = false;
    var dragged = false;
    var snap = '';

    function nearestSlide() {
      var kids = Array.prototype.slice.call(rail.children);
      var mid = rail.scrollLeft + rail.clientWidth / 2;
      var best = null;
      var bestGap = Infinity;
      kids.forEach(function (kid) {
        var centre = kid.offsetLeft + kid.offsetWidth / 2;
        var gap = Math.abs(centre - mid);
        if (gap < bestGap) { bestGap = gap; best = kid; }
      });
      return best;
    }

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pressed = true;
      dragged = false;
      startX = e.clientX;
      startScroll = rail.scrollLeft;
    });

    rail.addEventListener('pointermove', function (e) {
      if (!pressed) return;
      var dx = e.clientX - startX;
      if (!dragged && Math.abs(dx) < THRESHOLD) return;

      if (!dragged) {
        dragged = true;
        /* Mandatory snapping fights every intermediate scrollLeft we set, so it
           comes off for the duration of the drag and back on at the end. */
        snap = rail.style.scrollSnapType;
        rail.style.scrollSnapType = 'none';
        rail.classList.add('is-dragging');
        if (rail.setPointerCapture) rail.setPointerCapture(e.pointerId);
      }
      e.preventDefault();
      rail.scrollLeft = startScroll - dx;
    });

    function release(e) {
      if (!pressed) return;
      pressed = false;
      if (!dragged) return;

      rail.style.scrollSnapType = snap;
      rail.classList.remove('is-dragging');
      if (rail.releasePointerCapture && e && e.pointerId != null) {
        try { rail.releasePointerCapture(e.pointerId); } catch (err) { /* already released */ }
      }

      var target = nearestSlide();
      if (target) {
        rail.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    }

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('pointerleave', release);

    /* The photos are buttons that open the lightbox — without this, letting go
       after a drag counts as a click on whichever one ended up under the
       cursor. Capture phase so it runs before the button's own handler. */
    rail.addEventListener('click', function (e) {
      if (!dragged) return;
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }, true);

    /* A half-finished drag must not leave text selected across the rail. */
    rail.addEventListener('dragstart', function (e) {
      if (dragged) e.preventDefault();
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.slice
      .call(scope.querySelectorAll('[data-drag-scroll]'))
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
